import { Check, X, ShieldAlert, Users } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Avatar } from "@/components/Brand";

const TYPE_LABEL = { ai_filter: "IA filtrou", ai_block: "IA bloqueou", report: "Denúncia", panic: "PÂNICO", kick: "Expulsão" };

export function ModeratorSheet({ open, onOpenChange, queue, alerts, onApprove, onReject }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full sm:max-w-md overflow-y-auto" data-testid="moderator-sheet">
        <SheetHeader>
          <SheetTitle>Moderação da sala</SheetTitle>
        </SheetHeader>
        <section className="mt-6">
          <h4 className="mb-3 flex items-center gap-2 text-sm font-bold"><Users size={15} /> Fila "Quero Participar da Roda" ({queue.length})</h4>
          {queue.length === 0 && <p className="text-sm text-muted-foreground">Ninguém na fila agora.</p>}
          <div className="space-y-2">
            {queue.map((q) => (
              <div key={q.user_id} className="flex items-center gap-3 rounded-xl bg-white/5 p-3" data-testid={`queue-item-${q.user_id}`}>
                <Avatar name={q.name} src={q.avatar} size={34} />
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold">{q.name}</p>
                  {q.is_minor && <p className="text-[11px] text-[hsl(var(--gold))]">Menor de idade (termo parental ok)</p>}
                </div>
                <button onClick={() => onApprove(q.user_id)} className="grid h-9 w-9 place-items-center rounded-full bg-emerald-600 hover:bg-emerald-500" data-testid={`queue-approve-${q.user_id}`}><Check size={16} /></button>
                <button onClick={() => onReject(q.user_id)} className="grid h-9 w-9 place-items-center rounded-full bg-white/10 hover:bg-red-600" data-testid={`queue-reject-${q.user_id}`}><X size={16} /></button>
              </div>
            ))}
          </div>
        </section>
        <section className="mt-8">
          <h4 className="mb-3 flex items-center gap-2 text-sm font-bold text-violet-300"><ShieldAlert size={15} /> Alertas em tempo real</h4>
          {alerts.length === 0 && <p className="text-sm text-muted-foreground">Sem alertas nesta sessão. Histórico completo no Painel.</p>}
          <div className="space-y-2">
            {alerts.map((a) => (
              <div key={a.id} className={`rounded-xl border p-3 text-sm ${a.type === "panic" ? "border-red-500/50 bg-red-500/10" : "border-violet-500/30 bg-violet-500/10"}`} data-testid={`live-alert-${a.id}`}>
                <div className="flex items-center justify-between text-xs font-bold">
                  <span>{TYPE_LABEL[a.type]}</span>
                  <span className="text-muted-foreground">{new Date(a.created_at).toLocaleTimeString("pt-BR")}</span>
                </div>
                <p className="mt-1">{a.reason}</p>
                {a.user_name && <p className="text-xs text-muted-foreground">Perfil: {a.user_name}</p>}
                {a.excerpt && <p className="mt-1 text-xs italic text-muted-foreground">"{a.excerpt}"</p>}
              </div>
            ))}
          </div>
        </section>
      </SheetContent>
    </Sheet>
  );
}
